import React from 'react';
import styled from '@emotion/styled';
import { TextField, FormHelperText, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TextFieldStyled = styled(({ isError, ...otherProps }) => (
  <TextField {...otherProps} />
))(({ theme, isError }) => ({
  backgroundColor: theme.colors.dark.darkSlateBlue,
  borderRadius: theme.shape.borderRadius * 2.5,

  '& .MuiOutlinedInput-root': {
    color: isError && theme.palette.common.white,
    borderRadius: theme.shape.borderRadius * 2.5,
    border: isError
      ? `1px solid ${theme.colors.red}`
      : `1px solid ${theme.colors.dark.steelBlue}`,

    '& .MuiInputBase-input': {
      color: theme.colors.light.lightCyan,
      '&::-webkit-input-placeholder': {
        color: theme.colors.dark.steelBlue,
      },
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
    '@media(max-width: 379px)': {
      fontSize: theme.fonts.sizes.font12PX,
    },
  },
  // '& .MuiOutlinedInput-root:hover': {
  //   '& .MuiOutlinedInput-notchedOutline': {
  //     borderRadius: theme.shape.borderRadius * 2.125,
  //     border: isError
  //       ? `1px solid ${theme.colors.red}`
  //       : `1px solid ${theme.colors.dark.steelBlue}`,
  //   },
  // },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

const FormHelperTextStyled = styled(FormHelperText)(theme => ({
  margin: '-8px 0 20px 10px',
  color: theme.colors.red,
  fontSize: theme.fonts.sizes.font12PX,
}));

function InputTextField({
  type,
  styles,
  inputStyles,
  placeholder,
  value,
  isError,
  handleChangeInput,
  handleKeyUpInput,
  minlength,
  maxlength,
  StartAdornementIcon,
  ...otherProps
}) {
  const { t } = useTranslation('auth');

  return (
    <>
      <TextFieldStyled
        InputProps={{
          minLength: minlength,
          maxLength: maxlength,
          ...(StartAdornementIcon && {
            startAdornment: (
              <InputAdornment position="start">
                <StartAdornementIcon />
              </InputAdornment>
            ),
          }),
          style: inputStyles,
          autoComplete: 'off',
        }}
        type={type}
        variant="outlined"
        value={value}
        onChange={handleChangeInput}
        onKeyUp={handleKeyUpInput}
        placeholder={placeholder || ''}
        isError={isError}
        sx={styles}
        {...otherProps}
      />
      {isError && (
        <FormHelperTextStyled>{t('errorMessage')}</FormHelperTextStyled>
      )}
    </>
  );
}

export default InputTextField;
